import { TwoFaHelperProvider } from 'contexts/TwoFaCheckContext';
import { AuthProvider } from 'contexts/useAuth';
import { WhitelabelConfigProvider } from 'contexts/WhitelabelConfigContext';
import { TermsProvider } from 'contexts/TermsContext';
import { ContractsProvider } from 'contexts/ContractsContext';
import { useEffect } from 'react';
import { getVariable, getWhitelabelTag } from 'whitelabel';
export default function MasterContext({ children }: any) {
  useEffect(() => {
    document.title = getVariable('name') + ' - Acesso';
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link['rel'] = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link['href'] = getVariable('favicon');

    // O build publica um único public/manifest.json para todas as marcas; o de cada marca (nome e
    // ícones do "Instalar app") fica em public/whitelabels/<marca>, gerado no deploy.
    const tag = getWhitelabelTag();
    const manifest = document.querySelector<HTMLLinkElement>("link[rel='manifest']");
    if (tag && manifest) {
      manifest.href = `/whitelabels/${tag}/manifest.json`;
    }
  }, []);

  return (
    <div id="header">
      <WhitelabelConfigProvider>
        <AuthProvider>
          <TermsProvider>
            <ContractsProvider>
              <TwoFaHelperProvider>{children}</TwoFaHelperProvider>
            </ContractsProvider>
          </TermsProvider>
        </AuthProvider>
      </WhitelabelConfigProvider>
    </div>
  );
}
